import { Helmet } from 'react-helmet-async';
import { Build as BuildIcon } from '@mui/icons-material';
import { Box, Container, Link, Typography } from '@mui/material';

import { useWhatsAppClick } from '@/hooks/useWhatsAppClick';

/**
 * Shown to every role, students and parents included, while the API is down.
 * `apiUtils` keeps polling /health and swaps the app back the moment it
 * answers, which is what lets the copy promise the page comes back by itself.
 */
function MaintenancePage() {
  const handleWhatsAppClick = useWhatsAppClick('maintenance_page', {
    includeJourney: false,
  });

  return (
    <>
      <Helmet>
        <title>Briefly unavailable | DeepThink</title>
      </Helmet>
      <Container className="safe-mobile-all" maxWidth="sm">
        <Box
          sx={{
            mt: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <BuildIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />
          <Typography variant="h4" component="h1" gutterBottom>
            DeepThink is briefly unavailable
          </Typography>
          <Typography variant="body1" color="text.secondary">
            We’re on it. Keep this page open — it will come back by itself,
            usually within a few minutes. Anything you saved is safe.
          </Typography>
          <Link
            component="button"
            type="button"
            onClick={handleWhatsAppClick}
            sx={{
              mt: 2,
              cursor: 'pointer',
              textDecoration: 'none',
              color: 'primary.main',
              fontWeight: 500,
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Need help? Contact us on WhatsApp (8012 7012)
          </Link>
        </Box>
      </Container>
    </>
  );
}

export default MaintenancePage;
